import { useState } from "react";
import { Box, Container, Tab, Tabs } from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import ListAltIcon from "@mui/icons-material/ListAlt";
import AssessmentIcon from "@mui/icons-material/Assessment";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import Navbar from "../../../Navbar";
import Title from "../../../Title";
import NotAllow from "../../../viandas2/notAllow/NotAllow";
import ProveedoresPage from "../proveedores/pages/ProveedoresPage";
import MenusPage from "../menus/pages/MenusPage";
import DisponibilidadPage from "../disponibilidad/pages/DisponibilidadPage";
import PedidosRRHHPage from "../pedidos/pages/PedidosRRHHPage";
import ReportesPage from "../reportes/pages/ReportesPage";
import EtiquetasPage from "../etiquetas/pages/EtiquetasPage";
import SinPedirPage from "../sinPedir/pages/SinPedirPage";
import CargarPorUsuarioPage from "../cargarPorUsuario/pages/CargarPorUsuarioPage";

const TABS = [
  { value: "disponibilidad", label: "Disponibilidad", icon: <EventAvailableIcon /> },
  { value: "proveedores", label: "Proveedores", icon: <StorefrontIcon /> },
  { value: "menus", label: "Menús", icon: <RestaurantIcon /> },
  { value: "pedidos", label: "Pedidos", icon: <ListAltIcon /> },
  { value: "sinPedir", label: "Sin pedir", icon: <PersonOffIcon /> },
  { value: "cargarPorUsuario", label: "Cargar por otro usuario", icon: <PersonAddAlt1Icon /> },
  { value: "reportes", label: "Reportes", icon: <AssessmentIcon /> },
  { value: "etiquetas", label: "Etiquetas", icon: <LocalPrintshopIcon /> },
];

const ViandasRRHHPage = () => {
  const [tab, setTab] = useState("disponibilidad");
  const esAdminRRHH = localStorage.getItem("adminrrhh") === "1";

  if (!esAdminRRHH) {
    return (
      <>
        <Navbar />
        <NotAllow />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <Title titulo="Gestión de Viandas · RRHH" handleClose={() => window.history.back()} />

      <Container maxWidth="xl" sx={{ mt: 3, mb: 6 }}>
        <Box
          sx={{
            borderRadius: 3,
            border: "1px solid rgba(0,0,0,0.08)",
            overflow: "hidden",
            mb: 3,
          }}
        >
          <Tabs
            value={tab}
            onChange={(e, val) => setTab(val)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              bgcolor: "rgba(212,230,241,0.4)",
              "& .MuiTab-root": { textTransform: "none", fontWeight: 600, minHeight: 56 },
            }}
          >
            {TABS.map((t) => (
              <Tab key={t.value} value={t.value} label={t.label} icon={t.icon} iconPosition="start" />
            ))}
          </Tabs>
        </Box>

        {tab === "disponibilidad" && <DisponibilidadPage />}
        {tab === "proveedores" && <ProveedoresPage />}
        {tab === "menus" && <MenusPage />}
        {tab === "pedidos" && <PedidosRRHHPage />}
        {tab === "sinPedir" && <SinPedirPage />}
        {tab === "cargarPorUsuario" && <CargarPorUsuarioPage />}
        {tab === "reportes" && <ReportesPage />}
        {tab === "etiquetas" && <EtiquetasPage />}
      </Container>
    </>
  );
};

export default ViandasRRHHPage;
